import React from 'react'

const BuyProduct = () => {
  return (
    <div>BuyProduct</div>
  )
}

export default BuyProduct